import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { prepareSupplierMatchingSaga } from '../../Hooks/actionCreators';

const SubcategoryMatchesManager = () => {
  const dispatch = useDispatch();
  const { haveAllInitialMessagesArrived } = useSelector(
    (store) => store.optionalFormConfig
  );
  const components = useSelector((store) => store.components);
  const { visitorId } = useSelector((store) => store.userIdentities);
  const { showCustomerMatchesOnThankYouPage } = useSelector(
    (store) => store.supplierMatches
  );

  useEffect(() => {
    if (
      haveAllInitialMessagesArrived &&
      visitorId &&
      (Object.values(components).some(
        (component) => component.component?.type === 'supplier-match'
      ) ||
        showCustomerMatchesOnThankYouPage)
    ) {
      // When app loads store highest revenue brands for the subcategory against any supplier match components and trigger appropriate events.
      dispatch(prepareSupplierMatchingSaga());
    }
  }, [
    haveAllInitialMessagesArrived,
    visitorId,
    showCustomerMatchesOnThankYouPage,
  ]);

  return null;
};

export default SubcategoryMatchesManager;
